import React from 'react';
import {Box, CircularProgress, Flex} from "@chakra-ui/react";

const Loading = (props) => {
    return (
        <>
            {
                (props?.isLoading && props?.isLoading === true) &&
                <Box
                    zIndex={"9999"}
                    position={"fixed"}
                    bottom={0}
                    top={0}
                    left={0}
                    right={0}
                    backgroundColor={"rgba(255,255,255,0.80);"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                >
                    <CircularProgress isIndeterminate color='orange.300' />
                </Box>
            }
        </>
    );
};

export default Loading;
